<template>
	<div click.stop>
		<div class="modal is-active">
			<div class="modal-background" @click="cancel"></div>
			<div class="modal-card narrow">
				<header class="modal-card-head">
					<p class="modal-card-title">
						 {{ editRole.id ? $t('addrolemodal.edit_title_prefix') : $t('addrolemodal.new_title_prefix') }} {{ $t('addrolemodal.title_suffix') }}
					</p>
					<button class="delete" aria-label="close" @click="cancel"></button>
				</header>
				<section class="modal-card-body">
					<div class="field ">
						<label class="label">{{ $t('addrolemodal.name_label') }}</label>
						<div class="control">
							<input
								type="text"
								v-model="role.name"
								class="input"
								:placeholder="$t('addrolemodal.name_label')"
							/>
						</div>
					</div>
				</section>
				<footer class="modal-card-foot">
					<button
						class="button is-dark"
						:class="isLoading ? 'is-loading' : ''"
						:disabled="disableSave"
						@click="save"
					>
						<span class="icon is-info"><i class="fas fa-save"/></span
						><span>{{ $t('addrolemodal.save_button') }}</span>
					</button>
				</footer>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		editRole: Object
	},
	data() {
		return {
			role: {
				name: ''
			},
			isLoading: false
		};
	},
	computed: {
		disableSave() {
			return !this.role.name;
		}
	},
	methods: {
		save() {
			if (!this.isLoading) {
				this.$emit('save', this.role);
			}

			this.isLoading = true;
		},
		cancel() {
			this.$emit('cancel');
		}
	},
	created() {
		if (this.editRole) {
			Object.assign(this.role, this.editRole);
		}
	}
};
</script>
